/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Alternatives_H1Inputs */

const en_directory_alternatives_h1 = /** @type {(inputs: Directory_Alternatives_H1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Alternatives`)
};

const zh_directory_alternatives_h1 = /** @type {(inputs: Directory_Alternatives_H1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的替代工具`)
};

/**
* | output |
* | --- |
* | "{name} Alternatives" |
*
* @param {Directory_Alternatives_H1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_h1 = /** @type {((inputs: Directory_Alternatives_H1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_H1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_h1(inputs)
	return zh_directory_alternatives_h1(inputs)
});
export { directory_alternatives_h1 as "directory.alternatives.h1" }